<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">
                    <lg-form-input invalidFeedback="O ID RE deve ser informado!" description="" v-model="form.id"
                        label="ID RE:" cols="12" sm="2" />

                    <lg-form-input invalidFeedback="O número processo deve ser informado!" description=""
                        v-model="form.nroProcesso" label="Nº Processo:" cols="12" sm="3" />

                    <lg-form-input invalidFeedback="Informe um número de contrato válido!" description=""
                        v-model="form.nroContrato" label="Nº Contrato:" cols="12" sm="3" />



                    <b-col lg="4" sm="12" class="text-left">
                        <LgFinderPagePessoa id="findRequerente" label="Requerente:" @onselect="handleRequerente"
                            v-model="form.requerente" invalidFeedback="Informe um requerente!"
                            :prefix="prefix + title + ' > '" />
                    </b-col>

                    <b-col lg="4" sm="12" class="text-left">

                        <LgFinderPageTipoAquisicao id="LgFinderPageTipoAquisicao" label="Tipo Aquisição:"
                            @input="handleTipoAquisicao" v-model="form.tipoAquisicao"
                            invalidFeedback="Informe um tipo de aquisição!" :prefix="prefix + title + ' > '" />
                    </b-col>


                    <lg-form-input invalidFeedback="Informe uma nota fiscal válida!" description=""
                        v-model="form.notaFiscal" label="Nota Fiscal:" cols="12" sm="2" />


                    <lg-form-select @input="load" :disabled="statusBloqueado" v-model="form.status"
                        :loadFunction="statusList" labelFormGroupBind="Status:" label="descricao" cols="12" sm="2"
                        md="3" description=" " filterList="true" />

                    <b-col cols="3" class="text-left mt-3">
                        <b-form-checkbox @change="mudarSomenteAtrasados" v-model="form.somenteAtrasados" :value="true"
                            :unchecked-value="false">
                            Somente Registros Atrasados ({{ totalAtrasados }})
                        </b-form-checkbox>
                    </b-col>

                    <lg-form-date invalidFeedback="A data de deve ser informada!" description="" v-model="form.dataDe"
                        label="Data Recebimento de:" cols="12" sm="2" />

                    <lg-form-date invalidFeedback="A data limite deve ser informada!" description=""
                        v-model="form.dataAte" label="Até:" cols="12" sm="2" />

                    <b-col lg="8" sm="12" class="text-left">
                        <lg-finder-page-produto id="finderProdutoRegistroEntrada" @onselect="handleProdutoSelect"
                            v-model="form.produto" invalidFeedback="Produto deve ser informada!" description=""
                            :prefix="prefix + title + ' > '">
                        </lg-finder-page-produto>
                    </b-col>
                    <lg-form-date invalidFeedback="A data de deve ser informada!" description=""
                        v-model="form.dataCriacaoDe" label="Data Criação de:" cols="12" sm="2" />

                    <lg-form-date invalidFeedback="A data limite deve ser informada!" description=""
                        v-model="form.dataCriacaoAte" label="Até:" cols="12" sm="2" />

                    <b-col lg="8" sm="12" class="text-left">
                        <LgFinderPageAlmoxarifado id="findAlmoxarifado" label="Almoxarifado:"
                            @onselect="handleAlmoxarifado" v-model="form.almoxarifado"
                            invalidFeedback="Informe um requerente!" :prefix="prefix + title + ' > '" />
                    </b-col>

                    <lg-form-date invalidFeedback="A data de deve ser informada!" description=""
                        v-model="form.dataAtestoDe" label="Data Atesto de:" cols="12" sm="2" />

                    <lg-form-date invalidFeedback="A data limite deve ser informada!" description=""
                        v-model="form.dataAtestoAte" label="Até:" cols="12" sm="2" />


                    <b-col lg="3" sm="12" class="text-left">
                        <LgFinderPagePessoa id="findRequerente" label="Resp.Criação:" @onselect="handleRequerente"
                            v-model="form.requerente" invalidFeedback="Informe um requerente!"
                            :prefix="prefix + title + ' > '" />
                    </b-col>


                    <b-col lg="3" sm="12" class="text-left">
                        <LgFinderPagePessoa id="findRequerente" label="Resp.Atesto:" @onselect="handleRespAtesto"
                            v-model="form.respAtesto" invalidFeedback="Informe um requerente!"
                            :prefix="prefix + title + ' > '" />
                    </b-col>
                    <b-col lg="2" sm="12" class="mt-2">

                        <b-button id="localizarRE" size="sm" class="mr-1 ml-1" style="height: 30px;" pill
                            variant="primary" @click="load()">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="localizarRE" title="Localizar"></b-tooltip>
                        </b-button>



                        <b-button id="limparRE" class="ml-2" size="sm" style="height: 30px; width:40px;" pill
                            variant="primary" @click="clearForm">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="limparRE" title="Limpar"></b-tooltip>
                        </b-button>

                        <b-button v-if="podeAdicionarRegistro && temPrivilegioIncluir()" id="plus" size="md"
                            class="ml-2" style="min-width:50px;" variant="success" @click="showCadastro">
                            <div style="background:transparent !important">
                                <b-icon scale="1" icon="plus" />
                            </div>
                            <b-tooltip target="plus" title="Adicionar novo..."></b-tooltip>
                        </b-button>
                    </b-col>


                </b-form-row>
                <b-table style="overflow-x: auto;" responsive :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" show-empty>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template #empty>
                        <p>nenhum registro encontrado</p>
                    </template>
                    <template v-slot:cell(nroContrato)='row'>
                        <span>{{ row.item.nroContrato ? row.item.nroContrato : (row.item.contrato ?
                            row.item.contrato.numeroContrato
                            : '') }}</span>
                    </template>
                    <template v-slot:cell(editar)="row">
                        <b-button v-b-tooltip.hover.bottom="'Editar...'" v-if="temPrivilegioEditar(row.item)"
                            :id="row.index + 'edit-button'" class="my-2" size="sm" pill variant="primary"
                            @click="editar(row.item)">
                            <b-icon icon="pencil-square" />
                        </b-button>
                    </template>

                    <template v-slot:cell(remover)="row">
                        <b-button v-b-tooltip.hover.bottom="'Remover...'" v-if="emConferencia(row.item)"
                            :id="row.index + 'excluir'" class="my-2" size="sm" pill variant="primary"
                            @click="remove(row.item)">
                            <b-icon icon="trash-fill" />
                        </b-button>
                    </template>
                    <template v-slot:cell(view)="row">
                        <b-button v-b-tooltip.hover.bottom="'Visualizar...'" v-if="temPrivilegioDetalhar()"
                            :id="row.index + 'visualizar-button-carga'" class="my-2" size="sm" pill variant="primary"
                            @click="visualizar(row.item)">
                            <b-icon icon="eye" />
                        </b-button>
                    </template>
                    <template v-slot:cell(atesto)="row">
                        <b-button
                            v-b-tooltip.hover.bottom="emConferencia(row.item) ? 'Atesto...' : 'Continuar Atesto...'"
                            v-if="!emAtesto(row.item)" :id="row.index + 'atesto-button'" class="my-2" size="sm" pill
                            variant="primary" @click="atestar(row.item)">
                            <b-icon icon="check-square" />
                        </b-button>
                    </template>

                    <template v-slot:cell(documento)="row">
                        <b-button v-b-tooltip.hover.bottom="'Documento do Registro de Entrada...'"
                            :id="row.index + 'file-button'" class="my-2" size="sm" pill variant="primary"
                            @click="mostrarModalDocumento(row.item)">
                            <b-icon icon="file-earmark-text" />
                        </b-button>
                    </template>
                </b-table>

                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
        <RegistroEntradaForm :contrato="contrato" :idAutorizacao="idAutorizacao" v-if="showForm" :id="id"
            :isVisualizacao="isVisualizacao" :prefix="prefix + title + ' > '" @close="cancelar"></RegistroEntradaForm>
        <ModalDocumentosRegistroEntrada v-if="showModalDocumentos" @close="cancelar" :id="id"
            :prefix="prefix + title + ' > '" />
        <ModalAtestoRegistroEntrada :status="status" :id="id" v-if="mostrarModalAtesto" :prefix="prefix + title + ' > '"
            @close="cancelar"></ModalAtestoRegistroEntrada>

    </b-card>
</template>
<script>
import LgFinderPageAlmoxarifado from "@/components/Finders/LgFinderPageAlmoxarifado.vue"
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue"
import ModalDocumentosRegistroEntrada from "@/core/components/Modals/ModalDocumentosRegistroEntrada.vue"
import ModalAtestoRegistroEntrada from "./ModalAtestoRegistroEntrada.vue"

import LgFinderPageProduto from "@/components/Finders/LgFinderPageProduto.vue"
import ResourceService from "@/core/api/ResourceService"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import StatusEnum from "@/core/utils/StatusEnum"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import moment from "moment"
import RegistroEntradaForm from "./RegistroEntradaForm.vue"
import LgFinderPageTipoAquisicao from "@/components/Finders/LgFinderPageTipoAquisicao.vue"


export default {
    components: {
        LgFormInput,
        LgFormDate,
        LgFormSelect,
        LgFinderPageProduto,
        LgFinderPagePessoa,
        LgFinderPageAlmoxarifado,
        RegistroEntradaForm,
        ModalDocumentosRegistroEntrada,
        ModalAtestoRegistroEntrada,
        LgFinderPageTipoAquisicao
    },
    mixins: [ConfirmMixin, ListResourceMixin, FormResourceMixin],
    props: {
        empenho: {
            type: Object,
            default: null
        },
        contrato: {
            type: Object,
            default: null
        },

        podeAdicionarRegistro: {
            type: Boolean,
            default: true,
        },
        idAutorizacao: {
            type: Number,
            default: null
        },

        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Registro de Entrada"
        },
        idProcessocompra: {
            type: Number,
            default: null
        },
    },
    data() {
        return {
            listaStatus: [],
            statusBloqueado: false,
            status: {},
            mostrarModalAtesto: false,
            showModalDocumentos: false,
            totalAtrasados: 0,
            isVisualizacao: false,
            id: null,
            showForm: false,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: {},
            form: {
                tipoAquisicao: {},
                somenteAtrasados: false,
                id: "",
                nroProcesso: "",
                nroContrato: "",
                respAtesto: {},
                requerente: {},
                almoxarifado: {},
                pessoa: "",
                pessoas: [],
                produto: {},
                produtos: [],
                dataDe: "",
                dataAte: "",
                notaFiscal: "",
                status: { id: null, descricao: "Todos" },
                responsavel: {},
                idProcessocompra: this.idProcessocompra,
            },
        }
    },
    beforeMount() {
        this.$statusService = new ResourceService(`/api/status/tipo/42`)
        this.$service = new ResourceService("/api/registros-entrada")
        this.loadTotalAtrasados()
        this.load()
    },
    watch: {
        page() {
            this.load()
        },
    },
    computed: {
        tableFields() {
            return [
                {
                    key: "id", label: "ID RE", tdClass: (value, index, item) => {

                        return item.atrasado ? "text-danger p-1" : "p-1"
                    },
                },
                {
                    key: "nroProcesso", label: "Nº Processo",
                    tdClass: (value, index, item) => {
                        return item.atrasado ? "text-danger p-1 " : "p-1"
                    },
                },
                {
                    key: "nroContrato", label: "Nº Contrato", tdClass: (value, index, item) => {
                        return item.atrasado ? "text-danger p-1" : "p-1"
                    }
                },
                {
                    key: "notaFiscal", label: "Nota fiscal", tdClass: (value, index, item) => {
                        return item.atrasado ? "text-danger p-1" : "p-1"
                    },
                },
                {
                    key: "data",
                    label: "Data Entrada",
                    tdClass: (value, index, item) => {
                        return item.atrasado ? "text-danger p-1" : "p-1"
                    }, formatter: (data) => data ? moment(String(data)).format("DD/MM/YYYY") : "",
                },
                {
                    key: "dhCriacao",
                    label: "Data Criação",
                    tdClass: (value, index, item) => {
                        return item.atrasado ? "text-danger p-1" : "p-1"
                    }, formatter: (data) => moment(String(data)).format("DD/MM/YYYY"),
                },
                {
                    key: "responsavel.nome", label: "Requerente", tdClass: (value, index, item) => {
                        return item.atrasado ? "text-danger p-1" : "p-1"
                    },
                },
                {
                    key: "status.descricao", label: "Status", tdClass: (value, index, item) => {
                        return item.atrasado ? "text-danger p-1" : "p-1"
                    },
                },
                {
                    key: "almoxarifados", label: "Almoxarifados", tdClass: (value, index, item) => {
                        return item.atrasado ? "text-danger p-1" : "p-1"
                    },
                },

                { key: "view", label: " ", tdClass: "p-0" },
                { key: "editar", label: " ", tdClass: "p-0" },
                { key: "atesto", label: " ", tdClass: "p-0" },
                { key: "documento", label: " ", tdClass: "p-0" },
                { key: "remover", label: " ", tdClass: "p-0" },

            ]
        },
    },
    methods: {
        mudarSomenteAtrasados() {

            if (this.form.somenteAtrasados) {
                this.statusBloqueado = true;
                this.form.status = this.listaStatus.find(status => status.id === StatusEnum.EM_CONFERENCIA.value);
            }
            else {
                this.statusBloqueado = false;
                this.form.status = { id: null, descricao: "Todos" };
            }

            this.load();
        },
        handleTipoAquisicao(item) {
            this.form.tipoAquisicao = item;
            this.load();
        },
        async loadTotalAtrasados() {
            const params = {}
            if (this.idProcessocompra) {
                params.idProcessocompra = this.idProcessocompra
            }

            if (this.idAutorizacao != null) {
                params.autorizacao = this.idAutorizacao;
            }
            this.$service.getWithParams("getTotalAtrasado", params).then(response => {
                this.totalAtrasados = response.data
            })
        },
        abrirModalAtesto(item) {
            this.id = item.id
            this.status = item.status
            this.mostrarModalAtesto = true
        },
        async atestar(item) {

            try {
                await (this.$service.get("validar-atesto/" + item.id));
                this.abrirModalAtesto(item)
            }
            catch (error) {
                this.busy = false;
                this.$notify({
                    type: "warning",
                    message: error.response.data,
                })

            }

        },
        temPrivilegioDetalhar() {
            return verificaPrivilegio(PrivilegiosEnum.REG_ENTRADA_DATALHAMENTO)

        },

        temPrivilegioIncluir() {
            return verificaPrivilegio(PrivilegiosEnum.REG_ENTRADA_INCLUIR)
        },
        temPrivilegioEditar(registroEntrada) {
            switch (registroEntrada.status.id) {
                case StatusEnum.EM_CONFERENCIA.value: {
                    return verificaPrivilegio(PrivilegiosEnum.REG_ENTRADA_EDITAR)
                }
                case StatusEnum.ATESTANDO.value: {
                    return JSON.parse(localStorage.getItem("context")).usuario.master
                }
                case StatusEnum.ATESTO.value: {
                    return registroEntrada.editavel
                }
            }
            return false


        },


        async editar(item) {

            if (this.atestando(item)) {

                let response = await this.$confirm(
                    "Deseja modificar o status do Registro de Entrada para 'Em Conferência'? ")

                if (!response)
                    return


                await this.$service.put(`${item.id}/status`, { statusId: StatusEnum.EM_CONFERENCIA.value })

            }

            this.id = item.id
            this.mostrarRegistroEntradaForm()
        },
        async remove(item) {
            await this.$removeResource(item)
        },
        emAtesto(item) {
            return item.status.id == StatusEnum.ATESTO.value
        },
        atestando(item) {
            return item.status.id == StatusEnum.ATESTANDO.value
        },
        emConferencia(item) {
            return item.status.id == StatusEnum.EM_CONFERENCIA.value
        },

        visualizar(item) {
            this.id = item.id
            this.isVisualizacao = true
            this.mostrarRegistroEntradaForm()
        },
        handleRespAtesto(respAtesto) {
            this.form.respAtesto = respAtesto
            this.load()
        },
        cancelar() {
            this.id = null
            this.showForm = false
            this.showModalDocumentos = false
            this.mostrarModalAtesto = false
            this.isVisualizacao = false

            this.load()

        },
        mostrarModalDocumento(item) {
            this.id = item.id
            this.showModalDocumentos = true
        },
        showCadastro() {
            this.id = null
            this.mostrarRegistroEntradaForm()
        },
        mostrarRegistroEntradaForm() {
            this.showForm = true
        },
        clearForm() {
            this.form = {
                id: "",
                tipoAquisicao: {},
                nroProcesso: "",
                nroContrato: "",
                respAtesto: {},
                requerente: {},
                almoxarifado: {},
                pessoa: "",
                pessoas: [],
                produto: {},
                produtos: [],
                dataDe: "",
                dataAte: "",
                notaFiscal: "",
                status: { id: null, descricao: "Todos" },
                responsavel: {},
            }

            this.load()

        },
        handleAlmoxarifado(almoxarifado) {
            this.form.almoxarifado = almoxarifado
            this.load()
        },
        handleRequerente(requerente) {
            this.form.requerente = requerente
            this.load()
        },
        async load() {
            this.filtro = {}

            this.filtro.somenteAtrasados = this.form.somenteAtrasados

            if (this.form.id && this.form.id != "") {
                this.filtro.id = this.form.id
            }


            if (this.empenho && this.empenho.id)
                this.filtro.empenho = this.empenho.id;

            if (this.form.tipoAquisicao && this.form.tipoAquisicao.id) {
                this.filtro.tipoAquisicao = this.form.tipoAquisicao.id;
            }


            if (this.form.dataAtestoDe) {
                this.filtro.dataAtestoDe = new Date(this.form.dataAtestoDe).toLocaleDateString('pt-BR', {
                    timeZone: 'UTC'
                })
            }

            if (this.form.dataAtestoAte) {
                this.filtro.dataAtestoAte = new Date(this.form.dataAtestoAte).toLocaleDateString('pt-BR', {
                    timeZone: 'UTC'
                })
            }

            if (this.form.dataAtestoDe && this.form.dataAtestoAte) {
                const ini = new Date(this.form.dataAtestoDe);
                const fim = new Date(this.form.dataAtestoAte);

                if (ini > fim) {
                    this.busy = false;
                    this.$notify({
                        type: "danger",
                        message: "Informe as datas corretamente.",
                    });
                    return;
                }
            }


            if (this.form.dataCriacaoDe) {
                this.filtro.dataCriacaoDe = new Date(this.form.dataCriacaoDe).toLocaleDateString('pt-BR', {
                    timeZone: 'UTC'
                })
            }


            if (this.form.dataCriacaoAte) {
                this.filtro.dataCriacaoAte = new Date(this.form.dataCriacaoAte).toLocaleDateString('pt-BR', {
                    timeZone: 'UTC'
                })
            }

            if (this.form.dataCriacaoDe && this.form.dataCriacaoAte) {
                const ini = new Date(this.form.dataCriacaoDe);
                const fim = new Date(this.form.dataCriacaoAte);

                if (ini > fim) {
                    this.busy = false;
                    this.$notify({
                        type: "danger",
                        message: "Informe as datas corretamente.",
                    });
                    return;
                }
            }


            if (this.form.dataDe) {
                this.filtro.dataInicio = new Date(this.form.dataDe).toLocaleDateString('pt-BR', {
                    timeZone: 'UTC'
                })
            }

            if (this.form.dataAte) {
                this.filtro.dataFim = new Date(this.form.dataAte).toLocaleDateString('pt-BR', {
                    timeZone: 'UTC'
                })
            }

            if (this.form.dataDe && this.form.dataAte) {
                const ini = new Date(this.form.dataDe);
                const fim = new Date(this.form.dataAte);

                if (ini > fim) {
                    this.busy = false;
                    this.$notify({
                        type: "danger",
                        message: "Informe as datas corretamente.",
                    });
                    return;
                }
            }


            if (this.form.nroProcesso && this.form.nroProcesso != "") {
                this.filtro.nroProcesso = this.form.nroProcesso
            }

            if (this.form.notaFiscal && this.form.notaFiscal != "") {
                this.filtro.notaFiscal = this.form.notaFiscal
            }

            if (this.form.nroContrato && this.form.nroContrato != "") {
                this.filtro.nroContrato = this.form.nroContrato
            }

            if (this.form.requerente && this.form.requerente.id) {
                this.filtro.requerente = this.form.requerente.id
            }

            if (this.form.almoxarifado && this.form.almoxarifado.id) {
                this.filtro.almoxarifado = this.form.almoxarifado.id
            }

            if (this.form.status && this.form.status.id) {
                this.filtro.status = this.form.status.id
            }

            if (this.form.produto && this.form.produto.id) {
                this.filtro.produto = this.form.produto.id
            }

            if (this.form.respAtesto && this.form.respAtesto.id) {
                this.filtro.respAtesto = this.form.respAtesto.id
            }


            if (this.idProcessocompra) {
                this.filtro.idProcessocompra = this.idProcessocompra
            }

            if (this.contrato != null) {
                this.filtro.contrato = this.contrato.id;
            }

            if (this.idAutorizacao) {
                this.filtro.autorizacao = this.idAutorizacao;
            }

            this.busy = true

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,
            })

        },
        async statusList({ filter, page = 1 }) {
            var listaStatus = this.$statusService.findAll({ filter, page, limit: 5 })
            this.listaStatus = (await listaStatus).data.content;
            return listaStatus;
        },
        async handleProdutoSelect(produto) {
            this.form.produto = produto
            this.load()
        },

    },
}
</script>

<style scoped>
.text-danger {
    color: red;
}


.table th,
.table td {
    padding: 0 !important;
}
</style>